'use client';

import { useCallback, useState } from 'react';
import { useEventListener } from './useEventListener';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';

interface Size {
  width: number;
  height: number;
}

export const useElementSize = <T extends HTMLElement = HTMLDivElement>(): [(node: T | null) => void, Size] => {
  const [ref, setRef] = useState<T | null>(null);
  const [size, setSize] = useState<Size>({
    height: 0,
    width: 0,
  });

  const handleSize = useCallback(() => {
    setSize({
      height: ref?.offsetHeight || 0,
      width: ref?.offsetWidth || 0,
    });
  }, [ref]);

  useEventListener('resize', handleSize);

  useIsomorphicLayoutEffect(() => {
    handleSize();
  }, [ref]);

  return [setRef, size];
};

export default useElementSize;
